import { render, staticRenderFns } from "./cash-transfer-request.vue?vue&type=template&id=99536058&scoped=true&lang=pug"
import script from "./cash-transfer-request.vue?vue&type=script&lang=js"
export * from "./cash-transfer-request.vue?vue&type=script&lang=js"
import style0 from "@ui-common/vue-masked-input/dist/vue-masked-input.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./cash-transfer-request.vue?vue&type=style&index=1&id=99536058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99536058",
  null
  
)

export default component.exports